import { Component, Input, OnInit } from '@angular/core';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ListFilter } from 'src/app/core/list-filter.model';
import { PDxListItem } from 'src/app/core/PDxListItem.model';
import { ajaxCall, DataTablesResponse } from 'src/app/core/services/ajax-call.service';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { CatalogItemSummary } from '../models/catalog-item-summary.model';
import { VendorFileDetail } from '../models/vendor-file-information.model';

@Component({
  selector: 'app-vendor-file-item-list',
  templateUrl: './vendor-file-item-list.component.html',
  styles: [
  ]
})
export class VendorFileItemListComponent implements OnInit {

  @Input() isMaster: boolean;
  @Input() fileInfo: VendorFileDetail;

  showList: boolean = false;
  filter: CatalogItemListFilter;
  results: DataTablesResponse<CatalogItemSummary>;

  constructor(private ajax: ajaxCall,
    private confirmService: ConfirmService,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.resetFilters();
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  resetFilters(): void {
    this.filter = new CatalogItemListFilter(10, 'Item Desc.', 'asc');
    this.filter.vendorFileId = this.fileInfo.vendorFileId;
    this.hideTheList();
  }

  showTheList(): void {
    if (!this.showList) {
      this.loadList(true);
    }
  }

  hideTheList(): void {
    this.showList = false;
  }

  loadList = (reset: boolean = false) => {
    if (reset) {
      this.filter.page = 1;
    }
    this.ajax.MakeCall<DataTablesResponse<CatalogItemSummary>>('/Vendor/FullItemList', this.filter).then(results => {
      this.results = results;
      this.showList = true;
    }, () => { });
  }

  inputFieldChange(ev: KeyboardEvent): void {
    if (ev.key == 'Enter') {
      this.showTheList();
    }
  }

  deleteItem(itemId: string): void {
    if (this.isMaster) {
      this.confirmService.yesNoCancel('Delete Item?', 'Do you want to delete all instances of this item for this vendor?').then((yesNo: boolean) => {
        this.doDelete(itemId, yesNo);
      }, () => { });
    } else {
      this.doDelete(itemId, false);
    }
  }

  private doDelete(itemId: string, deleteAll: boolean): void {
    this.ajax.MakeCall('/Vendor/DeleteItem', { itemId: itemId, deleteAll: deleteAll }).then(results => {
      if (this.results.data.length == 1) {
        this.filter.page--;
      }
      this.loadList(false);
    }, () => { });
  }
}

class CatalogItemListFilter extends ListFilter {
  textFilter?: string;
  vendorFileId: string;
  vendorAccountNumber: string;
  pdxId: string;
}